import * as React from "react"

const PrintPageBreak = () => {
    return (
        <div className="print-page-break"></div>
    )
}

export default PrintPageBreak